window.addEventListener('DOMContentLoaded', function() {
  if (!Object.fromEntries) {
    Object.fromEntries = function fromEntries (iterable) {
      return [...iterable].reduce(function(obj, [key, val]) {
        obj[key] = val
        return obj
      }, {})
    }
  }
})
